function saveTokenInLocalStorage(tokenDetails){
    localStorage.setItem("token", tokenDetails);
}
function saveUserID(id){
    localStorage.setItem("id", id);
}
function saveUsername(name){
    localStorage.setItem("username", name);
}
function synclab(sync){
    localStorage.setItem("sync", sync);
}

function saveStaffid(staffid){
    localStorage.setItem("staffid", staffid);
}
function  saveRoleid(roleid){
    localStorage.setItem("roleid", roleid);
}

export{
    saveTokenInLocalStorage,
    saveUserID,
    saveUsername,
    synclab,
    saveStaffid,
    saveRoleid,
}